module.exports = __webpack_public_path__ + "static/media/icon-chevron-right.50d1412d.svg";